import template from './mx-styles-editor.component.html';

export class MxStylesEditorController {
	static $inject = ['$scope', '$ocLazyLoad', 'mx.internationalization'];
	constructor($scope, $ocLazyLoad, i18n) {
		this.id = 'id-' + Math.random().toFixed(20).substr(2);
		this.items = [];
		this.i18n = i18n;

		Promise.all([
			import(/* webpackChunkName: "ui.ace" */ 'ace-builds/src-min-noconflict/ace.js'),
			import(/* webpackChunkName: "ui.ace" */ 'ace-builds/src-min-noconflict/snippets/scss.js'),
			import(/* webpackChunkName: "ui.ace" */ 'ace-builds/src-min-noconflict/mode-scss.js'),
			import(/* webpackChunkName: "ui.ace" */ 'ace-builds/src-min-noconflict/ext-language_tools.js'),
			import(/* webpackChunkName: "ui.ace" */ 'angular-ui-ace/src/ui-ace.js'),
		]).then(() => {
			$ocLazyLoad.inject('ui.ace');
			$scope.$evalAsync(() => {
				this.lazyLoaded = true;

				this.editorOptions = {
					fontSize: 16,
					mode: 'scss',
					workerPath: 'workers',
					advanced: {
						enableSnippets: true,
						enableBasicAutocompletion: true,
						enableLiveAutocompletion: true,
						minLines: 5,
						showLineNumbers: false,
						showPrintMargin: false,
					},
				};
			});
		});

		$scope.$watch('vm.mxStyles', (styles) => {
			if (styles !== this.internalStyles) {
				this.setItems(this.formatElements, styles);
			}
		});
	}

	$onChanges(changes) {
		if (changes.formatElements) {
			this.setItems(changes.formatElements.currentValue, this.internalStyles);
		}

		if (changes.bodyStyles || changes.contentStyles) {
			this.updateCss();
		}
	}

	setItems(formatElementsStr = '', stylesStr = '') {
		this.internalStyles = stylesStr;
		this.styles = [];
		let formatElements = [];
		try {
			this.styles = JSON.parse(stylesStr) || [];
		} catch (e) {
			// console.error(e);
		}
		try {
			formatElements = JSON.parse(formatElementsStr) || [];
		} catch (e) {
			// console.error(e);
		}
		this.items = formatElements.map((element) => ({
			title: formatElements.length > 1 ? this.i18n.get(element.Title) || element.Title : element.Title,
			selector: element.Selector,
			css: this.styles.find(({ Selector }) => element.Selector === Selector)?.Css || '',
		}));

		this.updateCss();
	}

	updateOutput() {
		this.mxStyles = this.internalStyles = JSON.stringify(
			this.items.map(({ selector, css }) => ({
				Selector: selector,
				Css: css,
			}))
		);
		this.updateCss();
	}

	updateCss() {
		let bodyCss = '',
			contentCss = '';
		try {
			bodyCss = JSON.parse(this.bodyStyles)[0].Css || '';
		} catch (e) {
			bodyCss = '';
		}

		try {
			contentCss = JSON.parse(this.contentStyles)[0].Css || '';
		} catch (e) {
			contentCss = '';
		}

		this.bodyCss = `#${this.id} .mx-style-editor--preview__body { ${bodyCss}  } `;
		this.contentCss = `#${this.id} .mx-style-editor--preview__content { ${contentCss} } `;

		this.css =
			this.bodyCss +
			this.contentCss +
			this.items.reduce((accum, { title, selector, css }) => accum + (css ? `#${this.id} ${selector === 'root' ? title : selector} { ${css} } ` : ''), '');
	}
}

angular.module('mx.SolutionBuilderAgent').component('mxStylesEditor', {
	controller: MxStylesEditorController,
	controllerAs: 'vm',
	bindings: {
		formatElements: '<', //serialized Array<{Selector, Title}>
		mxStyles: '=', //serialized Array<{Selector, Css}>
		previewHtml: '<',
		contentStyles: '<',
		bodyStyles: '<',
		showOnlyPreview: '<',
	},
	template: template,
});
